
import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Image, ScrollView, Alert, TouchableOpacity, Keyboard, KeyboardAvoidingView, TouchableWithoutFeedback } from 'react-native';
import Fondo from '../modules/component/Fondo';
import { useNavigation } from '@react-navigation/native';
import theme from './../../lib/theme.js';
import { MaterialIcons, Ionicons, FontAwesome5, Entypo } from '@expo/vector-icons';
import { TextInput, Text, Snackbar, ActivityIndicator } from 'react-native-paper';
import CustomModal from './CustomModal';
import Incidencias from './Incidencias';
import { apiFetch } from '../modules/api';

const UPC = () => {
  const [isLoadingInventory, setIsLoadingInventory] = useState(false);
  const [snackBarVisible, setSnackBarVisble] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const navigation = useNavigation();
  const recargar = () => {

    navigation.replace(
      'UPC',
      null,
      null,


    );

  }

  /*async function validarGpsEncendido(){

    let { status } = await Location.requestForegroundPermissionsAsync();
    
        if (status !== 'granted') {
            setErrorMsg('Permission to access location was denied');
            gMsg = "Para poder utilizar esta aplicación es necesario dar permiso de ubicación a esta aplicación"
            showAlert();
            navigation.navigate("Acceso");
            return;
        }else{
          let location = await Location.watchPositionAsync(
            {accuracy:Location.Accuracy.High,
            timeInterval:5000,
            distanceInterval:10
          },
            (loc) => {
              gGeo = loc.coords;
            }
            );
        }
  }*/

  const showAlert = (titulo) => {
    alert(global.gMsg);
  }

  const [state, setState] = useState({

    exhibido: "",
    bodega: "",
    comentarios: gComentarios,

  });


  const [inv, setInv] = useState({

    exhibido: "",
    bodega: ""

  });




  const [foto, setFoto] = useState(null)
  const handleChangetest = (name, value) => {

    setState({ ...state, [name]: value })


  }


  function limpiarFormulario() {

    setState("", "", global.gComentarios);

  }





  function onChanged(propiedad, text) {

    handleChangetest(propiedad, text.replace(/[^0-9]/g, ''))

  }

  function SumarInv(accion, exhibido, bodega, comentarios) {

    Alert.alert('Sumar Inventario', 'Se agrego correctamente el inventario', [
      {
        text: "Aceptar",

      }
    ],
      { cancelable: true });

  }


  function restarInv(accion, exhibido, bodega, comentarios) {
    guardarInv(accion, exhibido, bodega, comentarios);
  }

  const base64Icon = gApiPathFotoUpc + gUpc + '.jpg';
  async function guardarInv(accion, exhibido, bodega, comentarios) {
    setIsLoadingInventory(true);
    /*  try{
      var altitude = gGeo.altitude
      var latitude = gGeo.latitude
      var longitude = gGeo.longitude
      var titulo = "";
      }catch{
  
        validarGpsEncendido();
  
  
      }*/

    var altitude = ""
    var latitude = ""
    var longitude = ""
    var titulo = "";

    var valoresenBlanco = 0;



    if (global.gInve == "NaN" || global.gInve === undefined) {

      global.gInve = "";

    }


    if (global.gInvb == "NaN" || global.gInvb === undefined) {

      global.gInvb = "";

    }


    if (exhibido == "NaN" || exhibido === undefined) {

      exhibido = "";

    }



    if (bodega == "NaN" || bodega === undefined) {

      bodega = "";

    }

    if (exhibido == "" && bodega == "") {


      valoresenBlanco = 1;

    }


    if (exhibido != "") {

      if (global.gInve != "") {

        if (accion == 0) {

          exhibido = String(parseFloat(gInve) + parseFloat(exhibido));
          global.gMsg = "El inventario se agregó correctamente";
          titulo = "Sumar inventario";

        } else {

          if (parseFloat(gInve) < parseFloat(exhibido)) {

            global.gMsg = "No puedes restar una cantidad mayor a lo registrado en exhibido";
            setIsLoadingInventory(false);
            showAlert("Restar Inventario");
            return;

          }

          exhibido = String(parseFloat(gInve) - parseFloat(exhibido));
          global.gMsg = "El inventario se restó correctamente";
          titulo = "Restar inventario";
        }

      }

    } else {

      if (accion == 1) {

        if (parseFloat(gInve) < parseFloat(exhibido)) {
          setIsLoadingInventory(false);
          global.gMsg = "No puedes restar una cantidad mayor a lo registrado en exhibido";
          showAlert("Restar Inventario");
          return;
        }

      }

      exhibido = global.gInve;

    }



    if (bodega != "") {

      if (global.gInvb != "") {

        if (accion == 0) {

          bodega = String(parseFloat(gInvb) + parseFloat(bodega));
          global.gMsg = "El inventario se agregó correctamente";
          titulo = "Sumar inventario";

        } else {

          if (parseFloat(gInvb) < parseFloat(bodega)) {
            setIsLoadingInventory(false);
            global.gMsg = "No puedes restar una cantidad mayor a lo registrado en bodega";
            showAlert("Restar Inventario");
            return;

          }

          bodega = String(parseFloat(gInvb) - parseFloat(bodega));
          global.gMsg = "El inventario se restó correctamente";
          titulo = "Restar inventario";

        }

      }

    } else {


      if (accion == 1) {

        if (parseFloat(gInvb) < parseFloat(bodega)) {
          setIsLoadingInventory(false);
          global.gMsg = "No puedes restar una cantidad mayor a lo registrado en bodega";
          showAlert("Restar Inventario");
          return;

        }

      }

      bodega = global.gInvb;

    }




    if ((exhibido != "" || bodega != "") && valoresenBlanco == 0) {




      var datos = '{"operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '", "upc" : "' + global.gUpc + '","inv_exhibido" : "' + exhibido + '","inv_bodega" :"' + bodega + '","comentarios" :"' + gComentarios + '","altitude":"' + altitude + '","latitude":"' + latitude + '","longitude":"' + longitude + '","inv_teorico":"' + gInvt + '"}'

      var requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: datos
      };

      const response = await apiFetch(gApiPath + "/api/guardarInv", requestOptions);
      const json = await response.json();
      setIsLoadingInventory(false);
      if (json.estatus == "bien") {
        setInv(exhibido, bodega);
        global.gInve = exhibido;
        global.gInvb = bodega;
        setState("", "", comentarios);
        Alert.alert("Registro de inventario", "El inventario se actualizo de manera correcta", [
          { text: "Aceptar" }
        ],
          { cancelable: true });
        recargar();

      }

    }

  }

  function irIncidencias() {
    gPantalla = "";
    gCheckbox = "";
    setModalVisible(true);
  }

  function irFotoProducto() {
    gFoto = "";
    gVerFoto = "";
    gMostrarFoto = "no";
    gImagen64 = "";
    gFoto1 = "";
    navigation.navigate("FotoProducto");
  }

  /*async function guardarComentario(comentarios){

    try{
    var altitude = gGeo.altitude;
    var latitude = gGeo.latitude;
    var longitude = gGeo.longitude;
    }catch{

      validarGpsEncendido();

    }

    if(global.gComentarios == "NaN" || global.gcomentarios === undefined){

      global.gComentarios = "";

    }

    
  
    if(comentarios != gComentarios){ 

      global.gComentarios = comentarios;
  
    var datos = '{"operador" : "' + global.gOperador + '","determinante" : "' + global.gDeterminante + '", "upc" : "' + global.gUpc + '","inv_exhibido" : "' + global.gInve + '","inv_bodega" :"'+ global.gInvb + '","comentarios" :"' + comentarios + '","altitude":"' + altitude + '","latitude":"'+ latitude + '","longitude":"'+longitude+'","inv_teorico":"' + global.gInvt + '"}' 
    var requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos
    };
    
      const response = await apiFetch(gApiPath + "/api/guardarInv",requestOptions);
      const json = await response.json();

      if (json.estatus == "bien"){
  
        global.gComentarios = comentarios;
        setState("","",comentarios);
        recargar();
       
        
      }

    }

  }*/

  useEffect(function () {

    global.gPantalla = "";
    let mounted = true;
    if (mounted) {
      setInv(
        {

          exhibido: global.gInve,
          bodega: global.gInvb

        });

      setState(
        {

          exhibido: "",
          bodega: "",
          comentarios: global.gComentarios

        });

    }

    return () => mounted = false;

  }, []);

  const validaDatos = (exhibido, bodega) => {
    if ((!exhibido && !bodega)) {
      return true;
    }
    if ((exhibido.trim() === "") &&
      (bodega.trim() === "" )) {
      return true;
    }
    return false;
  }

  return (
    <View style={styles.container}>
      <CustomModal modalVisible={modalVisible} setModalVisible={setModalVisible} Content={Incidencias} setSnackBarVisble={setSnackBarVisble} />
      <Fondo />
      <Snackbar
        visible={snackBarVisible}
        style={{ zIndex: 2 }}
        duration={3000}
        onDismiss={() => setSnackBarVisble(false)}
        action={{
          label: 'Cerrar',
          onPress: () => {
            setSnackBarVisble(false)
          },
        }}>
        Las incidencias se guardaron correctamente
      </Snackbar>
      <ScrollView style={styles.scrollView} keyboardShouldPersistTaps='handled'>
        <View style={{  height: "120px" , maxHeight: 130, width: "100%"}} >
          <View
            style={{
              ...theme.cards, backgroundColor: "#fff",
              flexWrap: 'wrap', flex: 1, height: 110, maxHeight: 130, justifyContent: "center"
            }}>
            <View style={{ alignItems: 'center', justifyContent: "center", height: "100%", marginRight: 10 }}>
              <MaterialIcons style={{ textAlign: 'center' }} name="local-grocery-store" size={50} color="#333" />
            </View>
            <View style={{ whiteSpace: "nowrap", maxWidth: 300 }}>
              <Text style={{ ...theme.subTitle, fontWeight: 'bold' }} ellipsizeMode="tail" numberOfLines={2}>UPC: {gUpc}</Text>
              <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{gDescripcionUpc}</Text>
            </View>
          </View>
        </View>
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ width: 250, height: 250, marginTop: "3%" }}>
            <Image style={{width: '100%', height: '100%'}} source={{ uri: base64Icon }} />
          </View>
          <View style={{ alignItems: 'center', flexDirection: 'row', flex: 1, marginVertical: "3%" }}>
            <Text style={{ ...theme.subTitle2, marginRight: '5%' }}>Teórico: <Text style={{ ...theme.subTitle2, fontWeight: 'bold' }}> {gInvt}</Text></Text>
            <Text style={{ ...theme.subTitle2, marginRight: '5%' }}>Inv. real: <Text style={{ ...theme.subTitle2, fontWeight: 'bold' }}> {(Number(gInve) + Number(gInvb))}</Text></Text>
            <Text style={{ ...theme.subTitle2, color: theme.colors.danger }}>Diferencia: <Text style={{ ...theme.subTitle2, fontWeight: 'bold', color: theme.colors.danger }}>{(Number(gInve) + Number(gInvb)) - gInvt}</Text></Text>
          </View>
          <View style={{ width: '95%', paddingHorizontal: "3%", flexDirection: 'row', flex: 1 }}>
            <View style={{ width: '50%', marginBottom: "10px" }}>
              <TouchableOpacity onPress={() => irIncidencias()} style={{ ...theme.buttonCardsSmall, ...theme.buttonContentCardsSmall, backgroundColor: theme.colors.primaryLight }}>
                <FontAwesome5 name="tasks" style={{ textAlign: 'center' }} size={30} color="#333" />
                <Text style={theme.buttonContentTextSmall}>Incidencias</Text>
              </TouchableOpacity>
            </View>
            <View style={{ width: '50%' }}>
              {!isLoadingInventory ? (
                <View style={{ width: '100%', alignItems: 'center', flexDirection: 'row', flex: 1, marginLeft: "5%" }}>
                  <TouchableOpacity style={{ marginRight: "5%" }} disabled={validaDatos(state.exhibido, state.bodega)} onPress={() => guardarInv(0, state.exhibido, state.bodega, state.comentarios)}>
                    <Ionicons name="add-circle-sharp" size={70} color={validaDatos(state.exhibido, state.bodega) ? theme.colors.gray : theme.colors.success} />
                  </TouchableOpacity>
                  <TouchableOpacity disabled={validaDatos(state.exhibido, state.bodega)} onPress={() => restarInv(1, state.exhibido, state.bodega, state.comentarios)}>
                    <Ionicons name="remove-circle-sharp" size={70} color={validaDatos(state.exhibido, state.bodega) ? theme.colors.gray : theme.colors.danger} />
                  </TouchableOpacity>
                </View>
              ) : (
                <View style={{ width: '100%', alignItems: 'center', marginTop: '20%' }}>
                  <ActivityIndicator animating={true} color={theme.colors.primary} size={"large"} />
                </View>
              )}
            </View>
          </View>
          <View style={{ width: '95%', paddingHorizontal: "3%", flexDirection: 'row', flex: 1 }}>
            <View style={{ width: '50%', marginTop: "10px" }}>
              <TouchableOpacity onPress={() => irFotoProducto()} style={{ ...theme.buttonCardsSmall, ...theme.buttonContentCardsSmall, backgroundColor: theme.colors.primaryLight }}>
                <Entypo name="camera" style={{ textAlign: 'center' }} size={30} color="#333" />
                <Text style={theme.buttonContentTextSmall}>Imágen</Text>
              </TouchableOpacity>
            </View>
            <View style={{ width: '50%', marginRight: "3%" }}>
              <TextInput
                label={"Exhibido: " + gInve}
                value={state.exhibido}
                onChangeText={(value) => onChanged("exhibido", value)}
                keyboardType="numeric"
                mode='outlined'
              />
              <TextInput
                label={"Bodega: " + gInvb}
                value={state.bodega}
                onChangeText={(value) => onChanged("bodega", value)}
                keyboardType="numeric"
                mode='outlined'
              />
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}

export default UPC


const styles = StyleSheet.create({
  container: {
    backgroundColor: '#f1f1f1',
    alignItems: 'center',
    height: '100%'
  },
  scrollView: {
    marginHorizontal: 20,
    width: '100%',
  },

  titulo2: {
    fontSize: 25,
    color: "white",
    fontWeight: 'bold'
  },

  subTitle2: {
    fontSize: 20,
    color: 'black',
    marginTop: 10,
    fontWeight: 'bold',
    textAlign: 'center'
  },

  subTitle3: {
    fontSize: 30,
    color: 'black',
    fontWeight: 'bold',
    textAlign: 'center'
  },
  textLabels: {

    padding: 5,
    width: '45%',
    fontWeight: 'bold',
    color: 'black',
    fontSize: 25,
    alignItems: 'center',
    justifyContent: 'center'
  },
  textLabelsdif: {

    padding: 5,
    width: '45%',
    fontWeight: 'bold',
    color: 'red',
    fontSize: 25,
    alignItems: 'center',
    justifyContent: 'center'
  },
  textLabels2: {

    padding: 5,
    width: '90%',
    fontWeight: 'bold',
    color: 'black',
    fontSize: 25,
    alignItems: 'center',
    justifyContent: 'center'
  },
  textInput: {

    width: '90%',
    height: 50,
    borderRadius: 10,
    fontWeight: 'bold',
    backgroundColor: '#ffff',
    fontSize: 40,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 5,
    textAlign: "center",
    borderColor: 'gray',
    borderWidth: 1

  },
  textInput2: {

    width: '90%',
    height: 50,
    borderRadius: 10,
    fontWeight: 'bold',
    backgroundColor: '#ffff',
    fontSize: 20,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 5,
    textAlign: "center"

  },
  text: {
    fontSize: 15,
    color: 'white',
    borderRadius: 30,
    marginTop: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase'

  }, imagen: {
    width: "50%",
    height: "100%",
    borderRadius: 70,
    alignItems: 'center',
    justifyContent: 'center'
  }, container2: {

    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    width: '34%'
  }, container3: {

    alignItems: 'center',
    justifyContent: 'center',

    width: '22%'
  }
});

